var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleavatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1742_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1743_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1744_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1745_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1746_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1747_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1748_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1749_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1750_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1751_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1752_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1753_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1754_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1769_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 68.07-26.58 129.94-69.91 175.8-.13.14-.27.28-.4.42-46.65 49.14-354.96 17.47-372.18-.84-43.1-45.82-69.51-107.52-69.51-175.38 0-141.38 114.62-256 256-256s256 114.62 256 256z",
    fill: "#5de9f4"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m205.038 289.115 194.014 161.39c19.785-4.137 34.854-10.086 42.638-18.285.13-.14.27-.28.4-.42 43.33-45.86 69.91-107.73 69.91-175.8 0-4.687-.13-9.344-.379-13.969l-160.596-160.597z",
    fill: "#4bc5ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5de9f4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.566 130.976c-4.452-38.584-27.605-61.679-52.172-75.447-40.331-22.604-89.797-22.79-129.544.826-23.327 13.86-45.052 36.798-49.416 74.621-10.136 87.847-6.757 231.442-6.757 231.442h244.647c0 .001 3.378-143.595-6.758-231.442z",
    fill: "#af5e22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.32 362.42h-122.32v-323.8c21.84.19 43.7 5.88 63.39 16.91 24.57 13.77 47.72 36.86 52.18 75.45 10.13 87.84 6.75 231.44 6.75 231.44z",
    fill: "#89491d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.6 260.446h92.799v98.413h-92.799z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 260.448h46.4v98.413h-46.4z",
    fill: "#d38c5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.251 152.225c-3.728-56.6-49.511-77.517-88.251-77.517s-84.523 20.917-88.251 77.517c-10.018 1.938-17.134 15.077-16.014 25.701l1.717 24.177c1.175 11.157 10.982 19.301 21.79 18.089l1.864-.202c22.138 59.446 56.857 65.644 78.894 69.125 22.038-3.48 56.756-9.678 78.894-69.125l1.864.202c10.807 1.212 20.614-6.932 21.79-18.089l1.717-24.177c1.12-10.624-5.996-23.763-16.014-25.701z",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.265 177.926-1.717 24.177c-1.175 11.157-10.982 19.301-21.79 18.089l-1.864-.202c-7.566 20.293-16.592 34.388-26.078 44.277-18.291 19.081-38.299 22.552-52.817 24.847v-214.406c38.74 0 84.523 20.917 88.251 77.517 10.019 1.938 17.135 15.077 16.015 25.701z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.49 400.662s-87.39 111.338-160.49 111.338c-46.41 0-89.93-12.35-127.46-33.94l-15.07-146.08c7.71-3.02 16.1-4.69 24.88-4.69h235.3c7.16 0 14.07 1.11 20.56 3.16 27.53 8.72 22.28 39.802 22.28 70.212z",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.092 402.352s-94.992 109.648-168.092 109.648v-184.71h117.65c7.16 0 14.07 1.11 20.56 3.16 27.53 8.72 29.882 41.492 29.882 71.902z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 64.762c-95.26 0-88.251 87.463-88.251 87.463 44.364 18.012 51.366-16.885 51.366-16.885 31.159 2.627 36.885-22.15 36.885-22.15s5.726 24.777 36.885 22.149c0 0 7.002 34.897 51.366 16.885 0 .001 7.009-87.462-88.251-87.462z",
    fill: "#af5e22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.25 152.22c-44.36 18.02-51.37-16.88-51.37-16.88-31.15 2.63-36.88-22.15-36.88-22.15v-48.43c95.26 0 88.25 87.46 88.25 87.46z",
    fill: "#89491d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.09 385.58v46.22c-46.67 49.38-112.78 80.2-186.09 80.2-73.52 0-139.8-30.99-186.49-80.62v-45.8c0-24.38 16.08-45.85 39.48-52.71l8.77-2.41 78.22 41.21c37.44 19.74 82.21 19.76 119.68.07l78.55-41.29 8.4 2.42c23.4 6.86 39.48 28.33 39.48 52.71z",
    fill: "#336b90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.09 385.58v46.22c-46.67 49.38-112.78 80.2-186.09 80.2v-125.51c20.49-.02 40.99-4.94 59.66-14.75l78.55-41.29 8.4 2.42c23.4 6.86 39.48 28.33 39.48 52.71z",
    fill: "#205077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.33 419.645v72.625c-11.17-4.66-21.95-10.11-32.25-16.25v-56.375z",
    fill: "#205077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.92 419.645v56.375c-10.3 6.14-21.08 11.59-32.25 16.25v-72.625z",
    fill: "#17416b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleavatar2);
export default __webpack_public_path__ + "static/media/Femaleavatar_2.e54b21fddd88e11af1c596ba2e999a65.svg";
export { ForwardRef as ReactComponent };